module.exports = __webpack_public_path__ + "static/bar-7af174cdd81a39c2d3188f5958bd3418.jpg";